import { generateConfidenceColors } from "./generateConfidenceColors";

// Rosé Pine Moon theme colors (OKLCH values)
// Based on the official Rosé Pine Moon palette
// https://rosepinetheme.com/palette/
// Converted using proper OKLab -> OKLCH conversion

const primary = "69.8% 0.156 4.224";  // love - vibrant pink
const content = "90.9% 0.030 289.969"; // text - soft white

export const rosePineMoonTheme = {
  name: "rose-pine-moon",
  default: false,
  prefersDark: true,
  colorScheme: "dark",
  colors: {
    // Base colors - layered backgrounds (purple-tinted darks)
    "base-100": "26.0% 0.039 287.730",    // base - primary background #232136
    "base-200": "28.8% 0.043 289.089",    // surface - secondary background #2a273f
    "base-300": "34.6% 0.050 289.834",    // overlay - tertiary background #393552
    "base-content": "90.9% 0.030 289.969", // text - high contrast text #e0def4

    // Primary colors - signature rose-pine pink/rose
    "primary": "69.8% 0.156 4.224",       // love - vibrant pink #eb6f92
    "primary-content": "26.0% 0.039 287.730", // base for contrast

    // Secondary colors - pine teal
    "secondary": "61.4% 0.093 228.003",   // pine - teal/cyan #3e8fb0
    "secondary-content": "26.0% 0.039 287.730", // base for contrast

    // Accent colors - iris purple
    "accent": "77.6% 0.095 304.994",      // iris - soft purple #c4a7e7
    "accent-content": "26.0% 0.039 287.730", // base for contrast

    // Neutral colors
    "neutral": "53.8% 0.044 291.412",     // muted - mid-tone gray #6e6a86
    "neutral-content": "90.9% 0.030 289.969", // text

    // Semantic colors
    "info": "82.2% 0.054 209.559",        // foam - light blue #9ccfd8
    "info-content": "26.0% 0.039 287.730", // base for contrast

    "success": "61.4% 0.093 228.003",     // pine - teal/cyan #3e8fb0
    "success-content": "26.0% 0.039 287.730", // base for contrast

    "warning": "84.3% 0.110 74.602",      // gold - warm yellow #f6c177
    "warning-content": "26.0% 0.039 287.730", // base for contrast

    "error": "69.8% 0.156 4.224",         // love - vibrant pink #eb6f92
    "error-content": "26.0% 0.039 287.730", // base for contrast

    // Confidence levels for Tamil learning
    ...generateConfidenceColors(primary, content, true)
  },
  dimensions: {
    "radius-selector": "0.5rem",
    "radius-field": "0.5rem",
    "radius-box": "0.5rem",
    "size-selector": "0.25rem",
    "size-field": "0.25rem",
    "border": "1px",
    "depth": "1",
    "noise": "0"
  }
};
